/* eslint-disable react/prop-types */
import React, { useContext, useState, useRef } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { UserCircleIcon } from '@heroicons/react/24/outline';
import MyAddressSVG from '../home/icons/my-details.svg';
import AttendanceSVG from '../home/icons/attendance.svg';
import OrderHistorySVG from '../home/icons/order-history.svg';
import customerSuppurtSVG from '../home/icons/customer-support.svg';
import settingsSVG from '../home/icons/settings.svg';
import AccountSVG from '../home/icons/account.svg';
import CloseSVG from '../home/icons/close.svg';
import { HeaderContext } from '../../contexts/headerContext';
import VideoPopup from '../shared/VideoPopup';
import ellipseSVG from '../home/icons/Ellipse.svg';
import EditSVG from '../home/icons/edit.svg';
import { getAuthToken, getCurrentOrganization } from '../../utils/helpers';
import { fileMaxSizeImage } from './forms/constants';
import { useFirebase } from '../../contexts/ssr-firebase-context';
import { useUser } from '../../contexts/ssr-user-context';
// import apiSetHeaders from './forms/constants';
const MAX_WIDTH = 300; // Max width in pixels
const MAX_HEIGHT = 300; // Max height in pixels
const IMAGE_QUALITY = 0.7; // 70% quality (JPEG compression)

// Error/Success Message Component
function MessageComponent({ message, type, onClose }) {
  if (!message) return null;

  const bgColor = type === 'error' ? 'bg-red-50' : 'bg-green-50';
  const textColor = type === 'error' ? 'text-red-700' : 'text-green-700';
  const borderColor = type === 'error' ? 'border-red-200' : 'border-green-200';

  return (
    <div className={`${bgColor} ${borderColor} border rounded-md p-4 mb-4`}>
      <div className="flex">
        <div className="flex-shrink-0">
          {type === 'error' ? (
            <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
            </svg>
          ) : (
            <svg className="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
          )}
        </div>
        <div className="ml-3 flex-1">
          <p className={`text-sm font-medium ${textColor}`}>
            {message}
          </p>
        </div>
        <div className="ml-auto pl-3">
          <div className="-mx-1.5 -my-1.5">
            <button
              type="button"
              className={`inline-flex rounded-md p-1.5 ${textColor} hover:bg-opacity-20 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-red-50 focus:ring-red-600`}
              onClick={onClose}
            >
              <span className="sr-only">Dismiss</span>
              <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function ProfilePopup({ isVisible, onClose }) {
  const { getConfigValue } = useFirebase();
  const profileDataConfig = getConfigValue('profile_data_config');

  // Parse profileDataConfig if it's a string
  const parsedConfig = typeof profileDataConfig === 'string'
    ? JSON.parse(profileDataConfig)
    : profileDataConfig;

  const menuData = parsedConfig?.data?.[0]?.data || [];

  const fileInputRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadMessage, setUploadMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'error' or 'success'

  // console.log('remoteConfigData pe', remoteConfigData);
  const { setUserRedirectPage } = useContext(HeaderContext);
  // eslint-disable-next-line no-unused-vars
  const { user, updateUser } = useUser();
  console.log('user in profile popup', user);
  const userStepComplete = user?.profile?.completeStepCount;
  const selectCourses = user?.enrolledBatches?.filter((res) => res?.showAttendance === true);
  // user?.enrolledBatches.filter((res) => res?.showAttendance === true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const [courseName, setSelectedCourse] = useState(selectCourses[0]?.name);

  const router = useRouter();
  const menuItems = [
    { label: 'My Details', icon: MyAddressSVG, url: '/user/profile' },
    { label: 'Account', icon: AccountSVG, url: '/user/account' },
    { label: 'Order History', icon: OrderHistorySVG, url: '/user/order-history' },
    { label: 'Student Support', icon: customerSuppurtSVG, url: '/student-support' },
    { label: 'Settings', icon: settingsSVG, url: '/settings' },
    { label: 'Attendance', icon: AttendanceSVG, url: '/attendance' },
  ];

  // Function to show message
  const showMessage = (message, type) => {
    setUploadMessage(message);
    setMessageType(type);
    // Auto-hide success messages after 3 seconds
    if (type === 'success') {
      setTimeout(() => {
        setUploadMessage('');
        setMessageType('');
      }, 3000);
    }
  };

  const hideMessage = () => {
    setUploadMessage('');
    setMessageType('');
  };

  // data.me.enrolledBatches
  const handleClose = () => {
    onClose(!isVisible);
  };

  const handleRoute = (url, label = '') => {
    if (url === '/attendance') {
      if (selectCourses?.length === 1) {
        handleClose();
        router.push(`/attendance/${selectCourses[0]?.id}`);
      } else {
        setIsModalOpen(true);
      }

      // router.push(`/attendance/${id}`);
    } else {
      setUserRedirectPage(router.pathname);
      if (label && label === 'My Details') {
        onClose(!isVisible);
        router.push('/user/profile-webview');
      } else {
        onClose(!isVisible);
        router.push(url);
      }
    }
  };

  const rediretToProfile = () => {
    setUserRedirectPage(router.pathname);
    onClose(!isVisible);
    router.push('/user/profile');
  };

  const selectHandle = (courseName1, id) => {
    setSelectedCourse(courseName1);
    setTimeout(() => {
      onClose(!isVisible);
      closeModal();
      router.push(`/attendance/${id}`);
    }, 500);
  };

  const handleClickProfileImageUpload = () => {
    console.log('click upload image');
    // Clear any previous messages
    hideMessage();
    // Trigger the hidden file input
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const resizeImage = (file, callback) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = (event) => {
      const img = new window.Image();
      img.src = event.target.result;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        let { width } = img;
        let { height } = img;

        // Maintain aspect ratio while resizing
        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob((blob) => {
          const resizedFile = new File([blob], file.name, { type: file.type });
          callback(resizedFile);
        }, file.type, IMAGE_QUALITY);
      };
    };
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];

    if (!file) {
      return;
    }

    // Validate file type
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      showMessage('Please select a valid image file (JPG, JPEG, or PNG)', 'error');
      return;
    }

    // Validate file size (e.g., max 2MB)
    // const maxSize = 2 * 1024 * 1024; // 2MB in bytes
    // if (file.size > maxSize) {
    //   showMessage('File size should be less than 2MB', 'error');
    //   return;
    // }

    // Create a preview URL for immediate display
    // const previewUrl = URL.createObjectURL(file);
    let previewUrl = '';
    if (file.size < fileMaxSizeImage) {
      console.log('no need resize');
      previewUrl = URL.createObjectURL(file);
    } else {
      console.log('need resize');
      resizeImage(file, async (resizedFile) => {
        previewUrl = URL.createObjectURL(resizedFile);
      });
    }
    try {
      setIsUploading(true);
      // Clear any previous messages
      hideMessage();
      setSelectedImage(previewUrl);
      const formData = new FormData();
      formData.append('file', file);
      const organization = getCurrentOrganization();
      const token = getAuthToken();
      const myHeaders = new Headers();
      myHeaders.append('organization', organization?.orgId || '2410f924-6cc4-4e88-b490-ffd3bbc40d03');
      myHeaders.append('device-type', '4');
      myHeaders.append('version-code', '22');
      myHeaders.append('account-role', 'student');
      myHeaders.append('Authorization', `Bearer ${token}`);
      // return;
      // Replace this with your actual API endpoint
      const response = await fetch(`${process.env.NEXT_PUBLIC_CORE_API_HOST}/auth/upload-profile-picture`, {
        method: 'POST',
        body: formData,
        headers: myHeaders,
      });

      if (response.ok) {
        const result = await response.json();
        showMessage('Profile picture updated successfully!', 'success');
        // update user context
        updateUser(() => ({
          ...user,
          profile: {
            ...user.profile,
            accountDetails: {
              ...user.profile.accountDetails,
              profilePicture: result?.data,
            },
          },
        }));
      } else {
        // throw new Error('Upload failed');
        showMessage('Upload failed', 'error');
      }
    } catch (error) {
      console.error('Error uploading image:', error);
      showMessage('Failed to upload image. Please try again.', 'error');

      // Reset the selected image on error
      setSelectedImage(null);
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    } finally {
      setIsUploading(false);
      // Reset the file input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  const listIconHtml = (title, index, width, ellipseWidth = 14) => (
    <span className="text-xl mb-2">
      <span className="relative">
        <Image width={width} height={56} src={menuItems[index].icon} alt={title} />
        {title === 'Order History1' ? (
          <span className="absolute top-0 right-[4px]">
            <Image width={ellipseWidth} height={56} src={ellipseSVG} alt={title} />
          </span>
        ) : ''}

      </span>
    </span>
  );

  if (isModalOpen) {
    return (
      <VideoPopup
        pageType="Attendance"
        onClose={closeModal}
        selectedCourseName={courseName}
        PopuptypeValue="change"
        courseClassUl="overflow-hidden overflow-y-auto max-h-[365px]"
        messageData={selectCourses}
        selectHandle={selectHandle}
      />
    );
  }

  // Get the current profile image URL (either selected image or existing profile picture)
  const currentProfileImage = selectedImage || user?.profile?.accountDetails?.profilePicture;

  return (
    <div className="h-screen flex items-center justify-center z-[1000]">

      {isVisible && (
        <div className={`fixed inset-0 flex top-0 justify-end ${
          isVisible ? 'translate-x-0' : '-translate-x-full'
        } transition-transform duration-300 bg-gray-900 bg-opacity-50`}
        >
          <div className="bg-white w-full lg:w-[470px] 2xl:w-[528px] p-6 rounded-lg shadow-xl relative lg:h-screen lg:overflow-y-auto">
            <div className="absolute top-0 flex justify-end right-3 cursor-pointer" onClick={handleClose}>
              <Image width={48} height={48} src={CloseSVG} alt="close" />
            </div>

            {/* Message Component */}
            <div className="mt-12 mb-4">
              <MessageComponent
                message={uploadMessage}
                type={messageType}
                onClose={hideMessage}
              />
            </div>

            {/* Profile Image */}
            <div className="flex flex-col items-center pb-6">
              <input
                ref={fileInputRef}
                type="file"
                accept=".jpeg,.jpg,.png"
                className="hidden"
                onChange={handleFileChange}
              />
              <div className="relative cursor-pointer border rounded-full ring-2 ring-gray-300 dark:ring-gray-500" onClick={handleClickProfileImageUpload}>

                {currentProfileImage
                  ? (
                    <div className="relative">
                      <Image
                        width={50}
                        height={50}
                        src={currentProfileImage}
                        alt="Profile"
                        className="w-20 h-20 rounded-full object-cover"
                      />
                      {isUploading && (
                        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded-full">
                          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white" />
                        </div>
                      )}
                      <div className="absolute bottom-[-5px] right-[-10px] w-[34px]">
                        <Image width={24} height={24} src={EditSVG} alt="edit" />
                      </div>
                    </div>
                  ) : (
                    <>
                      <UserCircleIcon width={80} height={80} />
                      <div className="absolute bottom-[-0.5rem] right-[-1.5rem] w-[34px]">
                        <Image width={24} height={24} src={EditSVG} alt="edit" />
                      </div>
                    </>
                  )}
              </div>

              <h2 className="mt-4 lg:mt-2 text-lg font-semibold">
                {user?.name}
              </h2>
              <p className="text-gray-500 mb-2">
                {user?.profile?.accountDetails?.mobile}
              </p>
              {userStepComplete !== 5 && (

              <CompleteProfileButton rediretToProfile={rediretToProfile} />
              )}

            </div>

            {/* Menu Options */}
            <div className="hidden lg:grid grid-cols-2 gap-6 overflow-y-auto lg:h-auto">
              {menuData.map((item, index) => {
                if ((item.title === 'Attendance' && selectCourses.length === 0)) {
                  return null;
                }
                return (
                  <button
                    type="button"
                    key={item.title}
                    className={`${index === 4 ? '' : ''} lg:mb-0 flex flex-col items-center justify-center p-6
                 hover:bg-thinBlue rounded-lg shadow-[0px_6px_4px_0px_rgba(0,0,0,0.03)] border border-[#EEEEEE]`}
                    onClick={() => handleRoute(menuItems[index].url)}
                  >
                    {listIconHtml(item.title, index, '56')}
                    <span>{item.title}</span>
                  </button>
                );
              })}
            </div>
            {/* for mobile menu */}
            <div className="grid lg:hidden grid-cols-2 gap-6 overflow-y-auto lg:h-auto">
              {menuData.map((item, index) => {
                if ((item.title === 'Attendance' && selectCourses.length === 0)) {
                  return null;
                }

                return (
                  <button
                    type="button"
                    key={item.title}
                    className={`${index === 4 ? '' : ''} mb-0 flex flex-col items-center justify-center p-6
                 hover:bg-thinBlue rounded-lg shadow-[0px_6px_4px_0px_rgba(0,0,0,0.03)] border border-[#EEEEEE]`}
                    onClick={() => handleRoute(menuItems[index].url)}
                  >
                    {listIconHtml(item.title, index, '36', '10')}
                    <span>{item.title}</span>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export function CompleteProfileButton({ rediretToProfile }) {
  return (
    <div>
      <button
        type="button"
        className="bg-[#E9F7FF] px-3 py-1 rounded text-customBlue text-base font-medium"
        onClick={rediretToProfile}
      >
        Complete your profile
      </button>
    </div>
  );
}

export function SelectBatchIDPopup({
  closeModal, courseName, PopuptypeValue, selectCourses, selectHandle,
}) {
  return (
    <VideoPopup
      ageType="Attendance"
      onClose={closeModal}
      selectedCourseName={courseName}
      PopuptypeValue={PopuptypeValue}
      courseClassUl="overflow-hidden overflow-y-auto max-h-[365px]"
      messageData={selectCourses}
      selectHandle={selectHandle}
    />
  );
}

export default ProfilePopup;
